module.exports = __webpack_public_path__ + "static/media/paul.6adb25ae.png";